(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SubscriptionPackageDeleteController', SubscriptionPackageDeleteController);

    SubscriptionPackageDeleteController.$inject = ['$uibModalInstance', 'entity', 'SubscriptionPackage'];

    function SubscriptionPackageDeleteController($uibModalInstance, entity, SubscriptionPackage) {
        var vm = this;

        vm.subscriptionPackage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            SubscriptionPackage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
